export default function InviteListItemSkeleton() {
	return (
		<div className="flex items-center justify-between py-4 animate-pulse">
			<div className="flex items-center gap-4">
				<div className="flex flex-col">
					{/* Email skeleton */}
					<div className="h-4 w-48 bg-gray-200 rounded" />
				</div>
			</div>

			<div className="flex items-center gap-3">
				{/* Role badge skeleton */}
				<div className="h-6 w-16 bg-gray-200 rounded" />
				{/* Resend button skeleton */}
				<div className="w-8 h-8 bg-gray-200 rounded" />
				{/* Delete button skeleton */}
				<div className="w-8 h-8 bg-gray-200 rounded" />
			</div>
		</div>
	);
}
